
import DialogTemplate from '@/_components/dialog/template/template.vue'
import CompanyInfoMixin from '@/_mixins/companyInfo.mixin.ts'
import CompanyAutocomplete from '@/components/Autocomplete/company.vue'
import { CREATE_ACCESS_GROUP_COMPANY_ASSOCIATION } from './gql/mutations'
import { accessClient } from '@/apolloClient'

export default {
    name: 'AccessControlUserRuleDialog',
    mixins: [CompanyInfoMixin],
    components: { CompanyAutocomplete, DialogTemplate },
    props: {
        props: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isAdding: false,
            company: null,
            selectedGroups: [],
        }
    },
    computed: {
        groups() {
            return this.props.groups || []
        },
    },
    methods: {
        async addCompany() {
            try {
                if (this.isAdding) {
                    return
                }

                this.isAdding = true
                const results = await Promise.all(
                    this.selectedGroups.map((groupId) =>
                        accessClient.mutate({
                            mutation: CREATE_ACCESS_GROUP_COMPANY_ASSOCIATION,
                            variables: {
                                companyId: this.company?.id || null,
                                groupId,
                            },
                        })
                    )
                )

                this.$emit('close', {
                    companyAdded: results.map(
                        (result: any) => result.data.createAccessGroupCompanyAssociation.association
                    ),
                })
            } finally {
                this.isAdding = false
            }
        },
    },
}
